import { FC } from "react";
import { Autocomplete, TextField } from "@mui/material";

import { InnovatricsDocumentTypes } from "../../../../data/innovatricsDocumentTypes";

type InnovatricsDocTypeSingleSelectProps = {
  label?: string;
  name?: string;
  value: string | null;
  onChange: (value: string | null) => void;
  required?: boolean;
  [x: string]: any;
};

/**
 * Single-select for Innovatrics document types. Values and callbacks use document type code string.
 */
export const InnovatricsDocTypeSingleSelect: FC<InnovatricsDocTypeSingleSelectProps> = ({
  label = "Document type",
  name = "documentType",
  value,
  onChange,
  required = false,
  ...rest
}) => {
  const selectedOption = InnovatricsDocumentTypes.find((option) => option.type === value) || null;

  return (
    <Autocomplete
      options={InnovatricsDocumentTypes}
      value={selectedOption}
      onChange={(_, newValue) => onChange(newValue?.type || null)}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.type === value.type}
      renderInput={(params) => (
        <TextField 
          {...params} 
          label={label} 
          variant="filled" 
          name={name}
          required={required}
        />
      )}
      {...rest}
    />
  );
};

export default InnovatricsDocTypeSingleSelect;
